// extracted by mini-css-extract-plugin
export default {"orText":"G08cbjJSs9ouipSOgwha","line":"FQ5yspmrzbs4nP5khvqh","row":"dAJ4hDbwv7yN6Xm_upSa","pulse":"LNwaH3RUqCC2Kx8kY0Xc"};